import actions from "./actions";
import columnConfigurationDialog from './columnConfigurationDialog';
import dataView from './dataView';
import formView from './formView';
import loginPage from './loginPage';
import mainMenu from './mainMenu';
import screenHeader from './screenHeader';
import screenTabHandleRow from './screenTabHandleRow';
import screenToolbar from './screenToolbar';
import selectionDialog from './selectionDialog';
import splitter from './splitter';
import tableView from './tableView';
import workQueues from './workQueues';
import workflow from './workflow';

export default {
  actions,
  columnConfigurationDialog,
  dataView,
  formView,
  loginPage,
  mainMenu,
  screenHeader,
  screenTabHandleRow,
  screenToolbar,
  selectionDialog,
  splitter,
  tableView,
  workQueues,
  workflow
}